<div class="sidebar-container h-full flex flex-column">
  <!-- Header -->
  <div class="flex align-items-center justify-content-between px-4 pt-4 pb-3">
    <h2 class="font-bold m-0" style="color: #CDD12A; font-size: 30px; letter-spacing: -0.5px; line-height: 1;">Messages</h2>
    <button class="bg-white border-none border-circle flex align-items-center justify-content-center cursor-pointer transition-colors" 
            style="width: 20px; height: 20px; color: #000086; padding: 0;"
            onmouseover="this.style.backgroundColor='#f3f4f6'"
            onmouseout="this.style.backgroundColor='#ffffff'"
            (click)="showNewChatDialog()">
        <span style="font-size: 16px; font-weight: 400; line-height: 0; margin-top: -1px;">+</span>
    </button>
  </div>

  <!-- Search -->
  <div class="search-container px-4 pb-3">
    <div class="search-box relative flex align-items-center px-4" style="height: 27px;">
        <input type="text" placeholder="search contacts" 
               [(ngModel)]="searchText"
               (input)="onSearch()"
               class="w-full bg-transparent border-none text-900 text-sm focus:outline-none m-0 p-0" style="line-height: 27px;">
    </div>
  </div>

  <!-- List -->
  <div class="conversation-list flex-1 overflow-y-auto custom-scrollbar" *ngIf="userPresence$ | async as presenceMap">
    <div *ngFor="let conv of filteredConversations$ | async" 
         (click)="select(conv)"
         class="conversation-item flex gap-3 cursor-pointer"
         [class.active]="(activeConversation$ | async)?.id === conv.id">
         
             <!-- Avatar -->
             <div class="relative flex-none">
                <p-avatar *ngIf="getAvatar(conv)" [image]="getAvatar(conv)!" shape="circle" size="normal" styleClass="w-2.5rem h-2.5rem"></p-avatar>
                <p-avatar *ngIf="!getAvatar(conv)" [label]="getInitials(conv.name)" shape="circle" size="normal" styleClass="w-2.5rem h-2.5rem font-bold text-lg" [style]="{'background-color': '#CDD12A', 'color': '#000086'}"></p-avatar>
            <ng-container *ngIf="getPresenceObj(presenceMap, conv) as presence">
                <div *ngIf="presence.presenceStatus === 1"
                     class="status-dot online border-circle" 
                     style="width: 10px; height: 10px; position: absolute; bottom: 0; right: 0;"></div>
            </ng-container>
         </div>

         <!-- Info -->
         <div class="flex-1 min-w-0 flex flex-column justify-content-center gap-1">
             <div class="flex justify-content-between align-items-center">
                 <span class="font-bold text-white">{{ conv.name || 'Unknown' }}</span>
                 <span class="text-xs text-white-alpha-70 font-medium" style="color: #e5e7eb;">{{ conv.lastMessageOn | date:'shortTime' }}</span>
             </div>
             <div class="flex justify-content-between align-items-center">
                 <ng-container *ngIf="(isTyping(conv.id) | async); else lastMsg">
                    <span class="text-sm font-semibold white-space-nowrap overflow-hidden text-overflow-ellipsis fadein animation-duration-300" style="max-width: 12rem; color: #cdd12a;">
                        Typing...
                    </span>
                 </ng-container>
                 <ng-template #lastMsg>
                    <span class="text-sm text-white-alpha-80 white-space-nowrap overflow-hidden text-overflow-ellipsis" style="max-width: 12rem; color: #d1d5db;">
                        {{ formatLastMessage(conv.lastMessageContent) }}
                    </span>
                 </ng-template>
                 <span *ngIf="conv.unreadCount > 0" class="unread-badge">
                     {{ conv.unreadCount }}
                 </span>
             </div>
         </div>
    </div>
  </div>

  <p-dialog header="New Chat" [(visible)]="displayNewChat" [modal]="true" 
            [draggable]="false" [resizable]="false" 
            styleClass="new-chat-dialog" 
            [style]="{width: '400px', height: '600px', maxWidth: '90vw'}">
     
     <div class="flex flex-column h-full">
        <!-- Search Area -->
        <div class="p-3 border-bottom-1 border-gray-100">
            <div class="search-box relative flex align-items-center px-3 py-2">
                <i class="pi pi-search text-700 mr-2"></i>
                <input type="text" placeholder="Search users..." 
                       class="w-full bg-transparent border-none text-900 text-sm focus:outline-none" 
                       (input)="onUserSearch($event)">
            </div>
        </div>

        <!-- User List -->
        <div class="flex-1 overflow-y-auto custom-scrollbar p-3">
             <div *ngFor="let user of chatUsers; trackBy: trackById" 
                  class="user-item flex align-items-center gap-3 cursor-pointer" 
                  (click)="startChat(user)">
                
                <div class="relative flex-none">
                    <p-avatar *ngIf="user.imageUrl" [image]="user.imageUrl" size="large" shape="circle"></p-avatar>
                    <p-avatar *ngIf="!user.imageUrl" [label]="getInitials(user.firstName)" size="large" shape="circle" styleClass="font-bold text-xl" [style]="{'background-color': '#CDD12A', 'color': '#000086'}"></p-avatar>
                    <div *ngIf="user.presenceStatus === 1"
                         class="status-dot online border-circle" 
                         style="width: 12px; height: 12px; position: absolute; bottom: 0; right: 0; border: 2px solid white; background-color: #22c55e;"></div>
                </div>
                
                <div class="flex flex-column gap-1">
                    <span class="font-bold text-900 text-base">{{user.firstName}} {{user.lastName}}</span>
                    <span class="role-badge w-fit">{{user.role}}</span>
                </div>
            </div>
            
            <!-- Empty State -->
            <div *ngIf="chatUsers.length === 0" class="flex flex-column align-items-center justify-content-center py-5 text-gray-500">
                <i class="pi pi-users text-4xl mb-2 text-gray-300"></i>
                <span class="text-sm">No users found</span>
            </div>
        </div>
     </div>
  </p-dialog>
</div>
